<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-document-orders'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-document-orders"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :items="myProvider"
          :fields="fields"
          :empty-text="$t('No matching records found')"
        >
          <template #cell(actions)="data">
            <b-button
              variant="primary"
              size="sm"
              @click="opendSettlementModal(data.item)"
            >
              Approve
            </b-button>
          </template>
          <template #cell(approveds)="data">
            {{ data.item.approveds }} / {{ data.item.total_documents }}
          </template>
        </b-table>
      </template>
    </filter-slot>
    <!-- 
        <document-order-modal
        v-if="showModal"
        :documentOrderId="documentOrderId"
        @hideModal="closeModal()"
        @refreshTable="refreshTable()"
        /> -->

    <settlement-modal
      v-if="showModal"
      :travelOrderId="travelOrderId"
      @hideModal="closeModal()"
    />
  </div>
</template>
<script>
import DocumentarySettlementsService from "@/views/operations/views/documentary-settlements/services/documentary-settlements.service.js";
import SettlementModal from "@/views/operations/views/documentary-settlements/modals/SettlementModal.vue";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/operations/views/documentary-settlements/data/documentary-settlements.fields.js";
import { mapGetters } from "vuex";
export default {
  components: {
    SettlementModal,
    FilterSlot,
  },
  data() {
    return {
      fields: Fields,
      showModal: false,
      travelOrderId: null,
      filters: [],
      filterPrincipal: {
          type: "input",
          inputType: "text",
          placeholder: "Search...",
          model: "",
      },
      paginate: {
          from: 0,
          to: 0,
          of: 0,
          perPage: 10,
          currentPage: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    async myProvider() {
      const params = {
          page: this.paginate.currentPage,
          perpage: this.paginate.perPage,
      //     search: this.filterPrincipal.model,
      //     from: this.filters[0].model,
      //     to: this.filters[1].model,
      //     fromLoad: this.filters[2].model,
      //     toLoad: this.filters[3].model,
      //     fromDelivery: this.filters[4].model,
      //     toDelivery: this.filters[5].model,
      };

      const { data } = await DocumentarySettlementsService.getTravelOrdersPendignSettlement(params);
      console.log("ooo", data)
      this.paginate.from = data.from;
      this.paginate.to = data.to;
      this.paginate.of = data.total;
      this.paginate.perPage = data.per_page;
      this.paginate.currentPage = data.current_page;
      return data.data;
    },
    opendSettlementModal(item) {
      this.travelOrderId = item.travel_order_id;
      this.showModal = true;
    },
    // async orderDocumentModal(item){
    //     this.documentOrderId = item.id;
    //     this.showModal = true;
    // },
    // async deleteDocument(item){
    //     const confirm = await this.showConfirmSwal();
    //     if (!confirm.isConfirmed) return;
    //     const params = {
    //         id: item.id,
    //         document_order_id: item.id,
    //         module_id: this.currentUser.modul_id,
    //         section_id: this.$route.meta.section,
    //         serie: item.serie,
    //         number: item.number,
    //         user_id: this.currentUser.employee_id
    //     }
    //     try {
    //         this.addPreloader();
    //         const { data } = await DocumentOrderService.deleteDocument(params)
    //         if(data.success){
    //             this.refreshTable();
    //             this.showToastSuccess("Successfull process");
    //         }else{
    //             this.showToastWarning("Error process");
    //         }
    //     } catch (error) {
    //         this.showToastError(error);
    //     } finally {
    //         this.removePreloader();
    //     }
    // },
    // refreshTable(){
    //     this.$refs['ref-table-document-orders'].refresh();
    // },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>